<template lang="pug">
#water_treatment
  section.banner.position-relative
    div.picture
        img.img-fluid.big(src="img/banner/banner_water_treatment.jpg" alt="banner-certificate")
        img.img-fluid.small(src="img/banner/banner_water_treatment_mobile.jpg" alt="banner-certificate")
    div.mask_banner
    div.breadcrumb_block
      b-container
        b-breadcrumb(:items="breadcrumb_items")
        //- router-link(to="/#application" ) 123
    div.banner_h1
      h1 Cooling Tower
  b-container.py-0.py-lg-5.slogan
    p.text-center.font-weight-bolder.py-5 Press working and forming process are good for the product.。Forming process has to regulate quality. 
  section#product_profile
    b-row.menu
      //- b-col.text-center.position-relative.active(v-scroll-to="'#others'") PVC
      b-col.text-center.position-relative.active(v-scroll-to="'#others'") PVC
    b-container.pt-md-4
      b-row#pvc_detail.detail.pb-5.py-md-5.active
        b-col(cols="12" md="8" order="2" order-md="1")
          div
            h3 
              span Product application description
            p Good Rigidity, Excellent chemical reistance ,heat distortion reistance. Reachable flame-resistant and smoke- resistant grade.
          div
            h3 
              span Product Features
            ol
              li(v-for="item in p_feature" :key="item.message") {{ item.message }}
          div
            h3 
              span Product Information
            ol.list-unstyled.pl-0
              li(v-for="item in p_use" :key="item.message") {{ item.message }}
          div
            h3 
              span Product Certificate
            a.linkcus(href="img/certification/VWWA_FF(ASTM_E84).pdf" target="_blank")
              figure
                figcaption VWWA FF (ASTM E84)
                img(src="img/certification/certification_VWWA_FF(ASTM_E84).jpg" alt="certification VWWA FF(ASTM E84)")
            a.linkcus(href="img/certification/VWWA_FE(ASTM_E84)-SGS.pdf" target="_blank")
              figure
                figcaption VWWA FE (ASTM E84)
                img(src="img/certification/certification_VWWA_FE(ASTM_E84)_2.jpg" alt="certification VWWA FE(ASTM E84)-SGS")
        b-col.align-self-center.text-center.pb-5.pb-md-0(cols="12" md="4" order="1" order-md="2")
          swiper.swiper.swiper_product_img(:options="swiperOption_product_img")
            swiper-slide(v-for="item in product_img_data" :key="item.id")
              b-img.w-100(:src="item.img_src",:alt="item.img_alt",:title="item.img_alt" )
            div.swiper-pagination(slot="pagination")
  section#specification.py-5.active
    div.mask
    h2.text-center 
      span PVC Specification
    b-container(fluid)
      swiper.swiper.py-5(:options="swiperOption_pvc").swiper_pvc.swiper_product_col_3
        swiper-slide(v-for="item in p_specification" :key="item.id")
          ul
            li 
              span {{ item.name }}
            li 
              span {{ item.feature }}
            li 
              span {{ item.outward }}
            li 
              span(v-html="item.thickness")
            li 
              span(v-html="item.proportion")
            li 
              span(v-html="item.pull")
            li 
              span(v-html="item.elongation")
            li 
              span(v-html="item.heating")
            li 
              span(v-html="item.vcm")
        <div class="swiper-pagination" slot="pagination"></div>
  section#video
    b-container.py-5
      h3.text-center.mb-4 Application of Water Tower Cooling Material
      div.embed-responsive.embed-responsive-16by9
        iframe.embed-responsive-item(src="https://www.youtube.com/embed/Ye7K8jGgC_c?rel=0" title="Application of Water Tower Cooling Material" )
  section#others.py-5 
    b-container
      h3 Others
      swiper.swiper.py-5(:options="swiperOption")
        swiper-slide(v-for="item in swiperdata" :key="item.id")
          div
            router-link(:to="item.href_link")
              div
                b-img.w-100(:src="item.url" fluid)
                h5 {{item.name}}
              p.py-4 {{item.text}}
              svg.o_arrow_r(viewbox="0 0 50 30")
                line(x1=0 y1=20 x2=45 y2=20)
                line(x1=45 y1=20 x2=31 y2=8)
        div.swiper-pagination(slot="pagination")
        div.swiper-button-prev(slot="button-prev")
          svg(width="65px" height="65px" viewBox="0 0 65 65" style="transform: scale( 1.75) rotate(180deg)")
            g(id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd")
              g(id="product" transform="translate(-1250.000000, -2680.000000)" stroke="#979797")
                  g(id="arrow" transform="translate(1282.500000, 2710.500000) rotate(-180.000000) translate(-1282.500000, -2710.500000) translate(1255.000000, 2683.000000)")
                    circle(stroke-width="1.1" fill="#FFFFFF" cx="27.3493151" cy="27.3493151" r="27.3493151")
                    polyline(stroke-width="3.3" stroke-linecap="round" stroke-linejoin="round" fill="none" points="29.0068493 19.0616438 20.7191781 27.3493151 29.0068493 35.6369863")
        div.swiper-button-next(slot="button-next")
          svg(width="65px" height="65px" viewBox="0 0 65 65" style="transform: scale( 1.75)")
            g(id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd")
              g(id="product" transform="translate(-1250.000000, -2680.000000)" stroke="#979797")
                  g(id="arrow" transform="translate(1282.500000, 2710.500000) rotate(-180.000000) translate(-1282.500000, -2710.500000) translate(1255.000000, 2683.000000)")
                    circle(stroke-width="1.1" fill="#FFFFFF" cx="27.3493151" cy="27.3493151" r="27.3493151")
                    polyline(stroke-width="3.3" stroke-linecap="round" stroke-linejoin="round" fill="none" points="29.0068493 19.0616438 20.7191781 27.3493151 29.0068493 35.6369863")
        

</template>
<script>
export default {
    metaInfo: {
        title: 'PVC Cooling Toward-NAN YA RIGID FILM',
        titleTemplate: '',
        meta: [
            { name: 'description', content: 'PVC RIGID FILM has Excellent chemical reistance ,heat distortion reistance, make it suitable for cooling water tower fillers and waster water treatment panels after the forming process to achieve water treatment results. There are regular type, heat resitance type, etc.' },
            { name: 'Keywords', content: 'Nan Ya Plastics, Rigid Film, PVC, Cooling Toward, Heat Resitance' },
            { name: 'og:title', content: 'PVC Cooling Toward-NAN YA RIGID FILM' },
            { name: 'og:type', content: 'website' },
            { name: 'og:url', content: 'https://www.nan-ya-pvc.com/' },
            { name: 'og:description', content: 'PVC RIGID FILM has Excellent chemical reistance ,heat distortion reistance, make it suitable for cooling water tower fillers and waster water treatment panels after the forming process to achieve water treatment results. There are regular type, heat resitance type, etc.' },
            { name: 'og:image', content: 'https://www.nan-ya-pvc.com/img/OGimage.jpg' },
        ],
    },
  data() {
      return {
        breadcrumb_items: [
          {
            text: 'Home',
            to: { name: 'App' }
          },
          {
            text: 'Cooling Tower',
            active: true
          }
        ],
        swiperOption_product_img: {
          slidesPerView: 1,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        },
        product_img_data: [
          { 
            id: '1',
            img_src: 'img/application_Desktop/water_treatment_img-01.jpg',
            img_alt: 'Nan Ya Rigid PVC has excellent chemical resistance and high thermal deformation temperature. It can be made into cooling water tower filling material or waste water treatment board,, which can improve the effect of water treatment.' },
          { 
            id: '2',
            img_src: 'img/application_Desktop/water_treatment_img-02.jpg',
            img_alt: 'Nan Ya Rigid PVC has excellent chemical resistance and high thermal deformation temperature. It can be made into cooling water tower filling material or waste water treatment board,, which can improve the effect of water treatment.' }
        ],
        p_show: [
          {show: true},
          {show: false}
        ],
        p_feature: [
          { message: 'Good Rigidity.' },
          { message: 'disperse water well to cool water.' },
          { message: 'Chemical resistance.' },
          { message: 'Heat Resistance' },
          { message: 'General grade, temperature-resistant grade, flame-resistant and smoke-resistant grade.' },
          { message: 'REACH、ROHS certificated.' }
        ],
        p_use: [
          { message: 'Suitable for cooling water tower fillers and waster water treatment panels after the forming process to achieve water treatment results.' }
        ],
        p_specification: [
          { 
            id: '1',
            name: 'Regular rVWWC',
            feature: 'Features: Good Rigidity、separate water well',
            outward: 'Appearance: Color、Gloss、Matt',
            thickness: 'Thickness<sub>(mm)</sub>：0.30 ',
            proportion: 'S.G.<sub>(g/cm3)</sub>：1.40±3%',
            pull: 'Tensile Strength<sub>(kg/cm2)</sub>:<br/><span class="pl-5">MD>400/CD>300</span>',
            elongation: 'Elongation<sub>(%)</sub>：<br/><span class="pl-5">MD>80/CD>80</span>',
            heating: 'Heat Shrinkage<sub>(%,150°CX10min)</sub>：<br/><span class="pl-5">MD-9~-16/CD<5</span>',
            vcm: 'VCM<sub>(ppm)</sub>：Unregulated' },
          { 
            id: '2',
            name: 'Heat Resitance VWWW',
            feature: 'Features: Good Rigidity、separate water well',
            outward: 'Appearance: Color、Gloss、Matt',
            thickness: 'Thickness<sub>(mm)</sub> ：0.30',
            proportion: 'S.G.<sub>(g/cm3)</sub> ：1.46±3%',
            pull: 'Tensile Strength<sub>(kg/cm2)</sub>：<br/><span class="pl-5">MD>450/CD>400</span>',
            elongation: 'Elongation<sub>(%)</sub> ：<br/><span class="pl-5">MD>80/CD>80</span>',
            heating: 'Heat Shrinkage<sub>(%,150°CX10min)</sub>：<br/><span class="pl-5">MD-6~-15/CD<3</span>',
            vcm: 'VCM(ppm)</sub>：Unregulated' },
          { 
            id: '3',
            name: 'Hlame Resistant VWWA',
            feature: 'Features: Comply with ASTM-E84, UL-94  flame -resistant and smoke-resistant, Good Rigidity, separate water well',
            outward: 'Appearance: Color、Gloss、Matt',
            thickness: 'Thickness<sub>(mm)</sub> ：0.30',
            proportion: 'S.G.<sub>(g/cm3)</sub> ：1.44±3%',
            pull: 'Tensile Strength<sub>(kg/cm2)</sub>：<br/><span class="pl-5">MD>450/CD>400</span>',
            elongation: 'Elongation<sub>(%)</sub> ：<br/><span class="pl-5">MD>80/CD>80</span>',
            heating: 'Heat Shrinkage<sub>(%,150°CX10min)</sub>：<br/><span class="pl-5">MD-6~-15/CD<3</span>',
            vcm: 'VCM(ppm)</sub>：Unregulated' }
        ],
        swiperOption_pvc: {
          slidesPerView: 3,
          spaceBetween: 30,
          breakpoints: {
            790: {
              spaceBetween: 30,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            },
            410: {
              spaceBetween: 10,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            }
          }
        },
        swiperOption: {
          slidesPerView: 3,
          spaceBetween: 51,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          breakpoints: {
            1024: {
              slidesPerView: 2,
              spaceBetween: 50
            },
            767: {
              slidesPerView: 1,
              spaceBetween: 50
            }
          }
        },
        swiperdata: [
          {
            id:'1',
            name:'Food and Medical use',
            text:'A flat plastic sheet is formed into a three-dimensional curved package by blister equipment which use high temperature and molds, so that consumers can directly see the product and protect it.',
            url:'./img/application_Desktop/other_pic_1.jpg',
            href_link: 'Food-and-medicine'
          },
          {
            id:'2',
            name:'Antistatic Packaging',
            text:'Using blister equipment, using high temperature and molds, the flat plastic sheet is formed into a three-dimensional packaging curved shell, so that consumers can directly see the product and protect it.',
            url:'./img/application_Desktop/other_pic_2.jpg',
            href_link: 'anti_static'
          },
          {
            id:'3',
            name:'Decoration Materials',
            text:'On a continuous substrate, products made through processes such as printing, coating, laminating or pressing. Composite plastic building materials decoration products are made by hot pressing of multi-layer structure, generally 3-5 layer structure laminated, including wear-resistant layer (including UV treatment layer), printed decoration layer, middle material layer, base material layer, etc..',
            url:'./img/application_Desktop/other_pic_3.jpg',
            href_link: 'decoration'
          },
          {
            id:'4',
            name:'Card Lamination',
            text:'This product can be processed into various cards through printing, laminating, card punching, coding, and sub-card quality inspection.',
            url:'./img/application_Desktop/other_pic_4.jpg',
            href_link: 'card_Lamination'
          },
          {
            id:'5',
            name:'For Stationery',
            text:'On a continuous substrate, products made through processes such as printing, coating, laminating or pressing for majority of Printing process.',
            url:'./img/application_Desktop/other_pic_5.jpg',
            href_link: 'office_stationery'
          },
          {
            id:'7',
            name:'Green Apet',
            text:'GREEN APET uses PCR resins made from recycled PET bottles as its raw material, reducing emissions of carbon and waste, providing consumers with an eco-friendly products.',
            url:'./img/application_Desktop/other_pic_7.jpg',
            href_link: 'green_apet'
          },
          {
            id:'8',
            name:'C-PET SHEET',
            text:'C-PET sheet is heated and further processed by compression molding machine so that the molded product can withstand high temperatures after crystallization.',
            url:'./img/application_Desktop/other_pic_8.jpg',
            href_link: 'Cpet-sheet'
          }
        ]
      }
    },
  methods: {
    change:function(item) {
      if(item === 'PVC'){
        this.p_show[0].show = true
        this.p_show[1].show = false
      }
      else{
        this.p_show[1].show = true
        this.p_show[0].show = false
      }
      // for(let i in this.p_show){
      //   this.p_show[i].show = !this.p_show[i].show
      // }
      // this.p_show[0].show = false
      // this.p_show[1].show = true
      // this.p_show = !this.p_show
      // for(let i=0; i<this.p_show.length; i++){
      //   this.p_show[i] = !this.p_show[i]
      //   console.log(i)
      // }
      // console.log(this.p_show[1] + "," + this.p_show[0])
      }
      // if(event){
      //   this.p_show[0] = true
      //   this.p_show[1] = true
      //   console.log(this.p_show[1])}
    // }
  },
}
</script>
<style lang="sass">
@import '@/css/product.sass'
#water_treatment
  #specification
    background-image: url(../assets/bg/bg_water_treatment.jpg)
.linkcus,.linkcus:hover
  text-decoration: none
  color: #1E1E1E
  figure
    padding-right: 15px
    text-align: center
    display: inline-block
    figcaption
      padding-bottom : 8px

</style>
